import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaveIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.8125 11C18.8125 12.0916 18.5975 13.1725 18.1798 14.1811C17.762 15.1896 17.1497 16.1059 16.3778 16.8778C15.6059 17.6497 14.6896 18.262 13.6811 18.6797C12.6725 19.0975 11.5916 19.3125 10.5 19.3125C9.40839 19.3125 8.32746 19.0975 7.31894 18.6797C6.31042 18.262 5.39406 17.6497 4.62217 16.8778C3.85029 16.1059 3.23799 15.1896 2.82025 14.1811C2.40251 13.1725 2.1875 12.0916 2.1875 11C2.1875 9.90838 2.40251 8.82746 2.82025 7.81894C3.238 6.81042 3.85029 5.89406 4.62218 5.12217C5.39407 4.35029 6.31043 3.73799 7.31895 3.32025C8.32747 2.90251 9.40839 2.6875 10.5 2.6875C11.5916 2.6875 12.6725 2.90251 13.6811 3.32025C14.6896 3.738 15.6059 4.35029 16.3778 5.12218C17.1497 5.89407 17.762 6.81043 18.1798 7.81895C18.5975 8.82747 18.8125 9.90839 18.8125 11L18.8125 11Z",
		stroke: "#E9EAEB",
		strokeWidth: 4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.5 2.6875C11.5916 2.6875 12.6725 2.90251 13.6811 3.32025C14.6896 3.73799 15.6059 4.35029 16.3778 5.12218C17.1497 5.89406 17.762 6.81043 18.1798 7.81894C18.5975 8.82746 18.8125 9.90839 18.8125 11",
		stroke: "currentColor",
		strokeWidth: 4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSaveIcon;
